import { arrayOf } from 'prop-types'

/**
 * @typedef {[function(FileList): boolean, string]} FilesValidation
 */
export const fileSelectValidation = arrayOf(function (propValue, i) {
    if ((i === 0 && typeof propValue[0] !== 'function') || (i === 1 && typeof propValue[1] !== 'string')) {
        return new Error(
            'Invalid "fileSelectValidation" prop value. Valid type should have an array of shape like [function: boolean, string]. First index should be the check function. Second index should be the error message.'
        )
    }
})
